import {RequestsService, UpdatesService} from '../services'
import { Breadcrumb } from 'ant-design-vue'

const today = Math.floor(Date.now()/1000)
const getClosestDate = (dates) => { 
    const upcomingDates = dates.filter(num => num.seconds > today)
    const updateDates = upcomingDates.length ? upcomingDates: dates 
    const closestDate = updateDates.reduce((a,b) => {
        const adiff = a.seconds - today
        return adiff > 0 && adiff < b.seconds ? a: b
    })
    return upcomingDates.length ? {...closestDate, upcoming: true} : closestDate
}

export const getRequestsList = (start, perPage, {must, should}, sortBy) => {

    return RequestsService.getRequests(start, perPage, {must: must, should: should}, sortBy).then(response => {
        const totalCount = response.data.total.value;
        const requests = response.data.hits.map(
                hit => ({
                    ...hit._source,
                    messageData: null,
                    platformData: null
                })
            ) || []

        return {
            totalCount,
            requests
        }
    }).catch(e => console.log(e))
}

export const setRequestStatus = (docId, status) => {
    return RequestsService.updateRequestData(docId, {status})
}

export const getRequestWithPartner = async (query, userId) => {
    const response = await RequestsService.getRequests(null, null, {should: query})
    if(!response.data.hits.length) {
        return null
    }
    const updateDates = response.data.hits.map(el => {
        const owner = el._source.receiver.uid === userId ? 'receiver' : 'sender'
        return {
            seconds: el._source[owner].update_date._seconds,
            type: owner,
            id: el._source[owner].update_date_id
        }
    })
    const closestDate = getClosestDate(updateDates)
    let requests = response.data.hits.filter(el => {
        const receiver = el._source.receiver.update_date._seconds === closestDate.seconds
        const sender = el._source.sender.update_date._seconds === closestDate.seconds
        return receiver || sender
    })

    const request = requests.filter(item => item._source[closestDate.type].update_date_id === closestDate.id)[0]

    const update = await UpdatesService.getUpdatesById(request._source[closestDate.type].update_date_id).get()
    const finalUpdate = update.exists ? {...update.data(), id: update.id} : null 

    return { 
        ...finalUpdate,
        upcoming: closestDate.upcoming
    }
}

export const getRequest = id => {
    return RequestsService.getRequest(id)
}

export const getPendingRequests = (query) => {
    return RequestsService.getPendingRequests(query)
}

export const getActualAcceptedRequests = (query) => {
    return RequestsService.getActualAcceptedRequests(query)
}